function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("highcharts"), require("vue")) : "function" == typeof define && define.amd ? define(["highcharts", "vue"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.HighchartsVue = e(require("highcharts"), require("vue")) : t.HighchartsVue = e(t.Highcharts, t.Vue);
}(window, function (r, n) {
  return c = {}, o.m = i = [function (t, e) {
    t.exports = r;
  }, function (t, e) {
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    r.r(e), r.d(e, "Chart", function () {
      return l;
    }), r.d(e, "default", function () {
      return h;
    });
    var e = r(0),
        c = r.n(e);

    function n(t, e) {
      return function r(n, o, i) {
        function t(t, e) {
          !c.a.isObject(t, !i) || c.a.isClass(t) || c.a.isDOMElement(t) ? n[e] = o[e] : n[e] = r(n[e] || c.a.isArray(t) ? [] : {}, t, i);
        }

        return c.a.isArray(o) ? o.forEach(t) : c.a.objectEach(o, t), n;
      }({}, t, e);
    }

    var o = r(1);

    function i(t) {
      return function (t) {
        if (Array.isArray(t)) return a(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return a(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          return "Map" === (r = "Object" === r && t.constructor ? t.constructor.name : r) || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? a(t, e) : void 0;
        }
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function a(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var r = 0, n = new Array(e); r < e; r++) {
        n[r] = t[r];
      }

      return n;
    }

    function u(e, t) {
      var r,
          n = Object.keys(e);
      return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(e), t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r)), n;
    }

    function s(n) {
      for (var t = 1; t < arguments.length; t++) {
        var o = null != arguments[t] ? arguments[t] : {};
        t % 2 ? u(Object(o), !0).forEach(function (t) {
          var e, r;
          e = n, t = o[r = t], r in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[r] = t;
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : u(Object(o)).forEach(function (t) {
          Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(o, t));
        });
      }

      return n;
    }

    function f() {
      this.chart && this.chart.destroy();
    }

    var p = function p(e, t) {
      t = t.split(".")[0] < 3 ? {
        render: function render(t) {
          return t("div", {
            ref: "chart"
          });
        },
        beforeDestroy: f
      } : {
        render: function render() {
          return Object(o.h)("div", {
            ref: "chart"
          });
        },
        beforeUnmount: f
      };
      return s({
        template: '<div ref="chart"></div>',
        props: {
          constructorType: {
            type: String,
            "default": "chart"
          },
          options: {
            type: Object,
            required: !0
          },
          callback: Function,
          updateArgs: {
            type: Array,
            "default": function _default() {
              return [!0, !0];
            }
          },
          highcharts: {
            type: Object
          },
          deepCopyOnUpdate: {
            type: Boolean,
            "default": !0
          }
        },
        watch: {
          options: {
            handler: function handler(t) {
              var e;
              (e = this.chart).update.apply(e, [n(t, this.deepCopyOnUpdate)].concat(i(this.updateArgs)));
            },
            deep: !0
          }
        },
        mounted: function mounted() {
          var t = this.highcharts || e;
          this.options && t[this.constructorType] ? this.chart = t[this.constructorType](this.$refs.chart, n(this.options, !0), this.callback || null) : this.options ? console.warn("'".concat(this.constructorType, "' constructor-type is incorrect. Sometimes this error is caused by the fact, that the corresponding module wasn't imported.")) : console.warn('The "options" parameter was not passed.');
        }
      }, t);
    },
        l = p(c.a, o.version || r.n(o).a.version);

    function h(t) {
      var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
      t.component(e.tagName || "highcharts", p(e.highcharts || c.a, t.version));
    }
  }], o.c = c, o.d = function (t, e, r) {
    o.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      o.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return r;
  }, o.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return o.d(e, "a", e), e;
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o.p = "", o(o.s = 2);

  function o(t) {
    if (c[t]) return c[t].exports;
    var e = c[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return i[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports;
  }

  var i, c;
});